class KukunModal {
    constructor(modalBackgroundWrapper, parameters) {
        this.backgroundWrapper = modalBackgroundWrapper;
        this.modalWrapper = this.backgroundWrapper.children[0];
        this.btnCloseModal = this.backgroundWrapper.querySelector('.k-modal-close');
        this.modalParameters = parameters;
        this.bodyIframe = window.document.body;
        this._addParameters();
        this._loadEvents();
    }

    _loadEvents() {
        if (this.modalParameters.closeWithWrapper) {
            this.backgroundWrapper.addEventListener('click', (e) => {
                const target = e.target;
                if (!this.modalWrapper.contains(target)) {
                    this.close();
                }
            })
        }

        if (this.btnCloseModal) {
            this.btnCloseModal.addEventListener('click', (e) => {
                this.close();
            })
        }

        if (this.backgroundWrapper.classList.contains('k-tooltip-modal')){
            this.modalContent = this.backgroundWrapper.querySelector('.k-modal-content-wrapper');
        }
    }
    _addParameters() {
        if(this.modalParameters.elmntContainer) {
            this.modalWrapper.classList.add(`k-width-${this.modalParameters.elmntContainer}`)
        }
        else {
            this.modalWrapper.classList.add(`k-width-md-40`)
        }
        this.modalWrapper.style.maxWidth = `${this.modalParameters.maxElmntWidth}px` || '600px'
        this.modalWrapper.style.overflowY = this.modalParameters.scrollable ? "auto" : "hidden"
    }

    open(viewportHeight = false) {
        this.backgroundWrapper.style.display = 'flex';

        if (viewportHeight) {
            if ( this.backgroundWrapper.classList.contains('add-another-project-modal') ){
                this.modalWrapper.style.maxHeight = `${viewportHeight - 100}px`;
            } else if(this.modalContent){
                this.modalContent.style.maxHeight = `${viewportHeight - 250}px`;
            }
        }

        setTimeout(() => {
            this.backgroundWrapper.style.opacity = '1';

            this.bodyIframe.style.overflow="hidden";
            this.backgroundWrapper.style.left = `-${this.backgroundWrapper.getBoundingClientRect().left}px`;
            this.backgroundWrapper.scrollIntoView(true, {block: "start", behavior: "smooth"});

            this.modalWrapper.classList.add('k-displayed-modal');
        }, 200);
    }

    close() {
        this.bodyIframe.style.overflow="auto";
        this.backgroundWrapper.style.left = `0`;
        this.backgroundWrapper.style.display = 'none';
        this.backgroundWrapper.style.opacity = '0';
        this.modalWrapper.classList.remove('k-displayed-modal');
    }

    toggle(viewportHeight = false) {
        if(this.modalWrapper.classList.contains("k-displayed-modal")) {
            this.backgroundWrapper.style.display = 'none';
            this.modalWrapper.classList.remove('k-displayed-modal');
        }
        else {
            this.backgroundWrapper.style.display = 'flex';

            if (viewportHeight) {
                if ( this.backgroundWrapper.classList.contains('add-another-project-modal') ){
                    this.modalWrapper.style.maxHeight = `${viewportHeight - 100}px`;
                } else if(this.modalContent){
                    this.modalContent.style.maxHeight = `${viewportHeight - 250}px`;
                }
            }
    
            setTimeout(() => {
                this.backgroundWrapper.style.opacity = '1';
                this.bodyIframe.style.overflow="hidden";
                this.backgroundWrapper.style.left = `-${this.backgroundWrapper.getBoundingClientRect().left}px`;
                this.backgroundWrapper.parentElement.scrollIntoView(true, {block: "start", behavior: "smooth"});

                this.modalWrapper.classList.add('k-displayed-modal');
            }, 200)
        }
    }

    remove() {
        this.backgroundWrapper.style.display = 'none';
        this.backgroundWrapper.style.visibility = 'hidden';
        this.modalWrapper.style.display = 'none';
    }
}

let modalInstances = [];

const init = (background_rappers, modalParameters) => {
    if (background_rappers) {
        if (typeof background_rappers.length == 'undefined') {
            const htmlElement = background_rappers;
            const parameters = modalParameters;
            modalInstances = new KukunModal(htmlElement, parameters);
        } else {
            for (let i = 0; i < background_rappers.length; i++) {
                const htmlElement = background_rappers[i];
                let modalInstance = new KukunModal(htmlElement);
                modalInstances.push(modalInstance);
            }
        }
    }

    return modalInstances;
}


export {
    init
};